module.exports = __webpack_public_path__ + "static/media/paredao_bueno.1030864b.mp4";